import MiniArtistCardContainer from './MiniArtistCard.container';
import MiniArtistCard from './MiniArtistCard';

export default MiniArtistCardContainer(MiniArtistCard);
